import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';

export interface HomeCSSStyle extends CRBTUICSSStyle
{
    getBannerCSSStyle(): object;
    getFeaturedCategoryCSSStyle(): object;
    getCategoriesCSSStyle(): object;
    getLogoCSSStyle():object;
    getMobileLogoCSSStyle():object;
    getBurmeseLogoCSSStyle():object;
}

export class HomeCSSStyleImpl extends CRBTUICSSStyleImpl implements HomeCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            height: '100%', 
            width: '100%',
            // display: "flex",
        };
    }
  getLogoCSSStyle():object{
      return{

      height: "auto",  width:"100%", display: "flex", flexFlow: "row wrap"
      };
  }
  getBurmeseLogoCSSStyle():object{
    return{

    height: "auto",  width:"100%", display: "flex", flexFlow: "row wrap",backgroundColor:this.getContext().getResources().getColor(Colors.color_38),
    };
}
  getMobileLogoCSSStyle():object{
    return{

    height: "auto",  width:"100%", display: "flex", flexFlow: "row wrap",
    };
}
    getInnerCSSStyle(): object 
    {
        return {
            height: '100%', 
            width: '100%', 
            marginBottom: "70px",
        };
    }

    getBannerCSSStyle(): object 
    {
        return {
            height: '300px', 
            width: '100%',  
        };
    }

    getFeaturedCategoryCSSStyle(): object 
    {
        return {
            height: '300px', 
            width: '100%',  
        };
    }

    getCategoriesCSSStyle(): object 
    {
        return {
            height: '300px', 
            width: '100%',  
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/home/homecss.tsx